const FilterSkeleton = () => {
    return (
        <div className="animate-pulse space-y-4 p-3">
            {/* Calendar Skeleton */}
            <div className="bg-gray-200 dark:bg-slate-700 rounded-lg p-3">
                <div className="flex items-center justify-between mb-3">
                    <div className="w-4 h-4 bg-gray-300 dark:bg-slate-600 rounded"></div>
                    <div className="w-20 h-4 bg-gray-300 dark:bg-slate-600 rounded"></div>
                    <div className="w-4 h-4 bg-gray-300 dark:bg-slate-600 rounded"></div>
                </div>
                <div className="grid grid-cols-7 gap-1 mb-2">
                    {Array.from({ length: 7 }).map((_, i) => (
                        <div key={i} className="w-6 h-4 bg-gray-300 dark:bg-slate-600 rounded text-center"></div>
                    ))}
                </div>
                <div className="grid grid-cols-7 gap-1">
                    {Array.from({ length: 35 }).map((_, i) => (
                        <div key={i} className="w-6 h-6 bg-gray-300 dark:bg-slate-600 rounded"></div>
                    ))}
                </div>
            </div>

            {/* Menu Filter Skeleton */}
            <div className="space-y-2">
                <div className="w-32 h-3 bg-gray-300 dark:bg-slate-600 rounded"></div>
                <div className="space-y-1">
                    {Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} className="flex items-center justify-between p-3 bg-gray-200 dark:bg-slate-700 rounded-lg">
                            <div className="flex items-center space-x-2 flex-1">
                                <div className="w-4 h-4 bg-gray-300 dark:bg-slate-600 rounded"></div>
                                <div className="flex-1 h-4 bg-gray-300 dark:bg-slate-600 rounded"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Status Filter Skeleton */}
            <div className="space-y-2">
                <div className="w-16 h-3 bg-gray-300 dark:bg-slate-600 rounded"></div>
                <div className="flex flex-wrap gap-1">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <div key={i} className="w-16 h-6 bg-gray-300 dark:bg-slate-600 rounded-full"></div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FilterSkeleton;
